import { Modal } from '../modal/Modal';

import styled from 'styled-components';
import { Button } from '../Button';
import { InputComponent } from '../form/InputComponent';
import { useState } from 'react';

export interface ModalDuplicateProductProps {
  show?: boolean;
  onClose: () => void;
  onCloneSurvey: (productName: string) => void;
  duplicatedProduct: { survey: any; version: any };
  isNewProductNameValid: (productName: string, productType: any) => boolean;
}

export const ModalDuplicateProduct = ({ show, onClose, onCloneSurvey, duplicatedProduct, isNewProductNameValid }: ModalDuplicateProductProps) => {
  const [newProductName, setNewProductName] = useState(null);

  return (
    <>
      <Modal
        alignment={'center'}
        size={{ width: '50%' }}
        show={show}
        title={`Quel nom souhaitez-vous donner à la copie de <b>${duplicatedProduct?.version?.versionName}</b> ?`}
        onClose={onClose}>
        <BasicModalContainer>
          <InputComponent
            focus={true}
            placeholder={'Nouveau nom ...'}
            sharable={false}
            label={'Nom de la copie'}
            type={'text'}
            onChange={e => setNewProductName(e.target.value)}
            error={
              newProductName &&
              newProductName?.trim().length !== 0 &&
              !isNewProductNameValid(newProductName, duplicatedProduct?.survey) &&
              'Ce nom est déjà utilisé'
            }
            value={newProductName}
          />
          <ButtonContainer>
            <Button
              onClick={() => onCloneSurvey(newProductName)}
              label={'Valider'}
              disabled={!isNewProductNameValid(newProductName, duplicatedProduct?.survey)}
            />
            <Button type={'light'} onClick={onClose} label={'Annuler'} />
          </ButtonContainer>
        </BasicModalContainer>
      </Modal>
    </>
  );
};

const BasicModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 20px;
  align-items: center;
  row-gap: 26px;

  p {
    font-size: 1.3em;
    font-weight: 400;
    font-family: 'Roboto', serif;
    line-height: 1.5em;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  column-gap: 20px;
  align-items: center;
`;
